<!--loading组件-->
<template>
	<div class="ELoading">
		<template v-if="!Msg">
			<div class="loadingCont" v-if="LoadingType == '1'">
				<div class="tit">{{Language.LG.LoadingTit[isLanguage]}}</div>
				<div class="cont">{{Language.LG.LoadingCont[isLanguage]}}</div>
			</div>
			<div class="loadingCont2" v-else-if="LoadingType == '2'">
				<img src="../../../../static/CEsite40s/images/loading.gif" class="loadImg" alt="">
				<text>{{Language.LG.Process[isLanguage]}}</text>
			</div>
		</template>
		<div class="loadingCont2" v-if="Msg">
			<img src="../../../../static/CEsite40s/images/loading.gif" class="loadImg" alt="">
			<text>{{Msg}}</text>
		</div>
	</div>
</template>

<script>
	import { storage } from '../../../../static/js/utils/utility'
	export default {
		props:{
			LoadingType:{
				type: String
			},
			Msg:{
				type: String
			}
		},
		data(){
			return {
				isLanguage: 0,
				Language:'',
			}
		},
		created(){
			var isLanguage = storage.localGetItem('isLanguage');
			if(isLanguage){
				this.isLanguage = isLanguage
			}
			this.Language = this.$Language
		},
	}
</script>

<style lang="less">
.ELoading{
	position: fixed;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0,0,0,.6);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 1000;
	.loadingCont2{
		width: 30%;
		background: #fff;
		padding: 0.2rem 0.5rem;
		border-radius: 0.1rem;
		font-size: 0.3rem;
		color: #151c36;
		display: flex;
		align-items: center;
		.loadImg{
			width: 0.7rem;
			height: 0.7rem;
			margin-right: 0.2rem;
		}
	}
	.loadingCont{
		width: 30%;
		background: #fff;
		padding: 0.2rem 0.5rem;
		border-radius: 0.1rem;
		font-size: 0.3rem;
		line-height: 2;
		.tit{
			font-weight: bold;
			color: #151c36;
		}
		.cont{
			color: #888;
			font-size: 0.26rem;
		}
		
	}
}
</style>



// WEBPACK FOOTER //
// src/components/CEsite40s/assets/Loading.vue